import { render } from "./index-search.vue?vue&type=template&id=373c70eb&scoped=true"
import script from "./index-search.vue?vue&type=script&lang=js"
export * from "./index-search.vue?vue&type=script&lang=js"

import "./index-search.vue?vue&type=style&index=0&id=373c70eb&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373c70eb"]])

export default __exports__